import React, { useCallback, useState } from "react";
import { graphql, useLazyLoadQuery, useMutation } from "react-relay";
import { LazyQueryNetworkBoundrary } from "../../../../../components/mobile/QueryNetworkBoundrary";
import { WAWidgetSizeToOverviewSize } from "../../WidgetAdd/utils/WAWidgetSizeToOverviewSize";

import { overviewWidgetSizes } from "../../WidgetAdd/utils/widgetSizes/overviewWidgetSizes";

import { UserLoggedInNavigatorScreenProps } from "../../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { WidgetScreen } from "../../common/WidgetScreen";
import { WASizePreview } from "../../WidgetAdd/WASizePreview/WASizePreview";
import { WidgetSizeT } from "../../localTypes/WidgetSizeT";
import { WidgetOverviewSettings } from "../WidgetOverviewSettings";
import { WACalendarPreview } from "./WACalendarPreview";
import { WACalendarQuery } from "./__generated__/WACalendarQuery.graphql";
import { WACalendarMutation } from "./__generated__/WACalendarMutation.graphql";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";

type Props = UserLoggedInNavigatorScreenProps<"WidgetAddCalendar">;

export const WACalendar = withWebModal(WACalendarC, true);
function WACalendarC(props: Props) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => <InnerWACalendar {...props} fetchKey={fetchKey} />}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerWACalendar(props: Props & { fetchKey: string }) {
  const data = useLazyLoadQuery<WACalendarQuery>(
    graphql`
      query WACalendarQuery {
        store {
          ...WidgetOverviewSettings_Store
        }
      }
    `,
    {},
    { fetchKey: props.fetchKey }
  );

  const [teamIds, setTeamIds] = useState(props.route.params.defaultTeams);

  const [createWidgetEmployeeSchedule, loading] =
    useMutation<WACalendarMutation>(graphql`
      mutation WACalendarMutation(
        $storecastId: ID!
        $input: CreateWidgetCalendarInput!
      ) {
        dashboard(dashboardId: $storecastId) {
          createWidgetCalendar(widget: $input) {
            id
          }
        }
      }
    `);

  const onCreate = useCallback(
    (size: WidgetSizeT) => {
      const position = props.route.params.position;
      createWidgetEmployeeSchedule({
        variables: {
          storecastId: props.route.params.storecastId,
          input: {
            positionX: position.x + position.c * 2,
            positionY: position.y,
            size: WAWidgetSizeToOverviewSize(size),
            teamIds,
          },
        },
        onError: (e) => {
          console.log("e", e);
        },
        onCompleted: () => {
          props.navigation.pop(2);
        },
      });
    },
    [
      createWidgetEmployeeSchedule,
      props.navigation,
      props.route.params.position,
      props.route.params.storecastId,
      teamIds,
    ]
  );

  const renderPreview = useCallback(
    () => <WACalendarPreview storecastId={props.route.params.storecastId} />,

    [props.route.params.storecastId]
  );
  return (
    <WidgetScreen
      preview={
        <WASizePreview
          onCreate={onCreate}
          loading={loading}
          unitSize={props.route.params.unitSize}
          maxSize={props.route.params.maxSize}
          widgetSizes={overviewWidgetSizes}
        >
          {renderPreview}
        </WASizePreview>
      }
      settings={
        <WidgetOverviewSettings
          setTeamIds={setTeamIds}
          teamIds={teamIds}
          store={data.store}
        />
      }
    />
  );
}
